import ListDetail from '../components/ListPage/ListDetail';

export default function ListPage() {
  return <ListDetail />;
}
